module.exports = __webpack_public_path__ + "static/media/dot-circle.36f07f08.svg";